import { Component, TemplateRef, OnInit } from "@angular/core";
import { BaseComponent } from "../base/base.component";
import { TranslateService } from "@ngx-translate/core";
import { TextModel } from "../../models/text";
import { TextService } from "../../services/text.service";
import { Discover } from "src/models/discover";
import { DiscoverService } from "../../services/discover.service";
import { PictureService } from "../../services/picture.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/services/guard/auth.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { EditDiscoverModalComponent } from "./edit-discover-modal/edit-discover-modal.component";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "app-discover",
  templateUrl: "./discover.component.html",
  styleUrls: ["./discover.component.scss"],
})
export class DiscoverComponent extends BaseComponent implements OnInit {
  modalRef: BsModalRef;

  discover1 = new TextModel();
  textModel: TextModel;

  discovers: Discover[];

  isPreview: boolean;
  mapDisplayed = false;

  hasScroll: boolean;

  constructor(
    public translate: TranslateService,
    private textService: TextService,
    private discoverService: DiscoverService,
    private pictureService: PictureService,
    private router: Router,
    authService: AuthService,
    private modalService: BsModalService,
    private toast: ToastrService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
    this.langChange.subscribe((lg) => this.getText());
  }

  ngOnInit() {
    this.getText();
    this.getDiscovers();
  }

  getText() {
    this.textService
      .getText("discover1.txt", this.translate.currentLang)
      .subscribe((data) => {
        this.discover1.textId = "discover1.txt";
        this.discover1.lang = this.translate.currentLang;
        this.discover1.text = data;
      });
  }

  getDiscovers() {
    this.discoverService.getDiscovers().subscribe((data) => {
      const pattern = /^[^\d]*(\d+)/;
      this.discovers = data.sort(
        (a, b) =>
          Number(
            a.titleFr.match(pattern) != null ? a.titleFr.match(pattern)[0] : "0"
          ) -
          Number(
            b.titleFr.match(pattern) != null ? b.titleFr.match(pattern)[0] : "0"
          )
      );
      this.discovers.forEach((x) => {
        this.pictureService
          .getMainPictureForDiscover(x.id)
          .subscribe((picture) => {
            if (!picture) {
              return;
            }
            x.picture = picture;
          });
      });
    });
  }

  selectDiscover(discover: Discover) {
    this.router.navigate([`/discover/${discover.id}`]);
  }

  getDiscoverTitle(discover: Discover) {
    const title = this.getDiscoverProperty(discover, "title");
    return title.replace(/^[^\d]*(\d+)/, "");
  }

  getDiscoverProperty(discover: Discover, property: string) {
    const lang =
      this.translate.currentLang.charAt(0).toUpperCase() +
      this.translate.currentLang.slice(1);
    return discover[property + lang];
  }

  getDiscoverNumber(discover: Discover) {
    const pattern = /^[^\d]*(\d+)/;
    return Number(
      discover.titleFr.match(pattern) != null
        ? discover.titleFr.match(pattern)[0]
        : "0"
    );
  }

  displayMap(display: boolean) {
    this.mapDisplayed = display;
  }

  scrollTop() {
    $(".discovers").scrollTop(0);
  }

  discoversScroll(e) {
    if (e.srcElement.scrollTop >= 300) {
      this.hasScroll = true;
    } else {
      this.hasScroll = false;
    }
  }

  //#region ADMIN
  updateText(text: TextModel, template: TemplateRef<any>) {
    if (!this.isAdmin) {
      return;
    }
    this.textModel = new TextModel();
    Object.assign(this.textModel, text);
    this.modalRef = this.modalService.show(template);
  }

  saveText() {
    this.textService.saveText(this.textModel).subscribe(
      () => this.toast.success("Text saved!"),
      (err) => {
        console.error(err);
        this.toast.error("Error while saving the text...");
      },
      () => {
        this.getText();
        this.modalRef.hide();
      }
    );
  }

  editDiscoverModal() {
    this.modalService.show(EditDiscoverModalComponent, { class: "large" });
  }

  //#endregion
}
